/* eslint-disable global-require */
/* eslint-disable  import/no-dynamic-require */
import React from 'react';
import { IntlProvider } from 'react-intl';

const parsedSearch = new URLSearchParams(window.location.search);

const supportedLocales = ['en', 'fr', 'de', 'es', 'it', 'nl', 'ja', 'pl', 'pt', 'ko', 'bg', 'cs', 'da', 'fi', 'hu', 'id', 'no', 'sv'];
export const localeMessages = supportedLocales.reduce((res, val) => ({ ...res, [val]: require(`../translations/translated/${val}.json`) }), {});
export function EventLocaleWrapper({ event, children }) {
  const locale = event.get('locale', 'en').split('_')[0];

  return (
    <IntlProvider key={locale} locale={locale} defaultLocale="en" messages={localeMessages[locale]}>
      {React.cloneElement(children)}
    </IntlProvider>
  );
}

export const WIDGET_LOCALE = parsedSearch.get('lang') || parsedSearch.get('regionalLanguage') || 'en';

export function LocaleWrapper({ children }) {
  return (
    <IntlProvider key={WIDGET_LOCALE} locale={WIDGET_LOCALE} defaultLocale="en" messages={localeMessages[WIDGET_LOCALE]}>
      {React.cloneElement(children)}
    </IntlProvider>
  );
}
